import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const empty = { campeonato_id: '', nome: '', numero: '' };

export default function AdminRodadas() {
  const [rodadas, setRodadas] = useState([]);
  const [campeonatos, setCampeonatos] = useState([]);
  const [campSel, setCampSel] = useState('');
  const [form, setForm] = useState(empty);
  const [editando, setEditando] = useState(null);
  const [msg, setMsg] = useState('');

  useEffect(() => { api.get('/campeonatos').then(setCampeonatos).catch(() => {}); }, []);

  useEffect(() => {
    if (!campSel) { setRodadas([]); return; }
    api.get(`/rodadas/campeonato/${campSel}`).then(setRodadas).catch(() => {});
  }, [campSel]);

  async function salvar(e) {
    e.preventDefault(); setMsg('');
    try {
      const payload = { ...form, campeonato_id: campSel };
      if (editando) { await api.put(`/rodadas/${editando.id}`, payload); }
      else { await api.post('/rodadas', payload); }
      setMsg('Salvo!'); setForm(empty); setEditando(null);
      api.get(`/rodadas/campeonato/${campSel}`).then(setRodadas);
    } catch (err) { setMsg(err.message); }
  }

  async function deletar(id) {
    if (!window.confirm('Remover?')) return;
    await api.delete(`/rodadas/${id}`);
    api.get(`/rodadas/campeonato/${campSel}`).then(setRodadas);
  }

  return (
    <div>
      <h2 className="admin-title">Rodadas</h2>
      {msg && <div className="alert alert-success">{msg}</div>}
      <div className="form-group">
        <label>Campeonato</label>
        <select value={campSel} onChange={e => setCampSel(e.target.value)}>
          <option value="">Selecione</option>
          {campeonatos.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
        </select>
      </div>
      {campSel && (
        <form onSubmit={salvar} className="admin-form">
          <h3>{editando ? 'Editar' : 'Nova Rodada'}</h3>
          <div className="form-row">
            <div className="form-group"><label>Nome</label><input value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} required /></div>
            <div className="form-group"><label>Número</label><input type="number" value={form.numero} onChange={e => setForm({ ...form, numero: e.target.value })} required /></div>
          </div>
          <div className="admin-actions">
            <button type="submit" className="btn btn-primary">Salvar</button>
            {editando && <button type="button" className="btn btn-secondary" onClick={() => { setEditando(null); setForm(empty); }}>Cancelar</button>}
          </div>
        </form>
      )}
      <div className="admin-table-wrap">
        <table>
          <thead><tr><th>Nº</th><th>Nome</th><th>Ações</th></tr></thead>
          <tbody>
            {rodadas.map(r => (
              <tr key={r.id}>
                <td>{r.numero}</td><td>{r.nome}</td>
                <td>
                  <div className="admin-actions">
                    <button className="btn btn-secondary" onClick={() => { setEditando(r); setForm({ nome: r.nome, numero: r.numero }); }}>Editar</button>
                    <button className="btn btn-danger" onClick={() => deletar(r.id)}>Remover</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
